// full-leaderboard.js (UPDATED with name search)
// Shopify variant that matches Denver-local backend filtering
(function () {
  const ROOT_SELECTOR = '[data-full-leaderboard]'

  const PERIOD_TITLES = {
    month: 'Month',
    ytd: 'YTD',
    all: 'All-Time',
    custom: 'Custom'
  }

  const formatCurrency = (value) => {
    const number = Number(value ?? 0)
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(number / 100)
  }

  const formatDate = (value) => {
    const date = typeof value === 'string' ? new Date(value) : value
    if (!date || Number.isNaN(date.getTime())) return null
    return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
  }

  const startOfDay = (date) => (date ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0) : null)
  const endOfDay = (date) => (date ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999) : null)

  const ensureStyles = () => {
    if (document.getElementById('full-leaderboard-styles')) return
    const style = document.createElement('style')
    style.id = 'full-leaderboard-styles'
    style.textContent = `
      .pd-btn {
        border-radius: 999px;
        border: 1px solid transparent;
        padding: 6px 14px;
        font-size: 0.8rem;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        transition: all 0.2s ease;
        background: transparent;
        color: #9ca3af;
        cursor: pointer;
      }
      .pd-btn.active {
        background: rgba(255, 255, 255, 0.12);
        color: #fff;
        border-color: rgba(255, 255, 255, 0.25);
      }

      .pd-table {
        border-collapse: collapse;
        width: 100%;
        font-family: inherit;
        color: #f8fafc;
      }
      .pd-table th,
      .pd-table td {
        padding: 10px 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.15);
      }
      .pd-table th {
        text-transform: uppercase;
        letter-spacing: 0.08em;
        font-size: 0.65rem;
        color: rgba(148, 163, 184, 0.8);
        font-weight: 600;
      }
      .pd-table tbody tr:last-child td {
        border-bottom: none;
      }
      .pd-table td {
        font-size: 0.9rem;
      }

      .pd-hidden { display: none !important; }
      .pd-modal {
        position: fixed;
        inset: 0;
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
      }
      .pd-modal__backdrop {
        position: absolute;
        inset: 0;
        background: rgba(0,0,0,0.7);
      }
      .pd-modal__panel {
        position: relative;
        width: min(520px, 92vw);
        border-radius: 16px;
        border: 1px solid rgba(255,255,255,0.18);
        background: #0b0b0b;
        color: #fff;
        padding: 18px;
        box-shadow: 0 24px 60px rgba(0,0,0,0.55);
      }
      .pd-modal__top {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 16px;
        margin-bottom: 14px;
      }
      .pd-modal__title {
        font-size: 18px;
        font-weight: 700;
        line-height: 1.2;
      }
      .pd-modal__link {
        background: transparent;
        border: 0;
        color: rgba(156, 163, 175, 1);
        cursor: pointer;
        padding: 6px 10px;
        border-radius: 999px;
      }
      .pd-modal__grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
        margin-top: 10px;
      }
      .pd-modal__label {
        font-size: 12px;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: rgba(148, 163, 184, 0.9);
        margin-bottom: 6px;
      }
      .pd-modal__input {
        width: 100%;
        border-radius: 10px;
        border: 1px solid rgba(255,255,255,0.18);
        background: rgba(255,255,255,0.06);
        color: #fff;
        padding: 10px 12px;
        font: inherit;
      }
      .pd-modal__actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        margin-top: 16px;
      }
      .pd-modal__btn {
        border-radius: 999px;
        border: 1px solid rgba(255,255,255,0.18);
        padding: 8px 14px;
        font-size: 0.85rem;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        background: transparent;
        color: #fff;
        cursor: pointer;
      }
      .pd-modal__btn--ghost { color: rgba(156, 163, 175, 1); }
      .pd-modal__btn--primary {
        background: rgba(255,255,255,0.14);
        border-color: rgba(255,255,255,0.22);
      }

      @media (max-width: 520px) {
        .pd-modal__grid { grid-template-columns: 1fr; }
      }
    `
    document.head.appendChild(style)
  }

  const resolveApiBase = (root) => {
    const attrValue = root.dataset.apiBaseUrl?.trim()
    if (attrValue) return attrValue.replace(/\/+$/, '')
    const globalValue = window.PROFESSIONAL_DASHBOARD_API_URL || window.PROFESSIONAL_DASHBOARD_API_BASE_URL
    if (globalValue) return `${globalValue}`.replace(/\/+$/, '')
    return null
  }

  const parseIntSafe = (value, fallback) => {
    const parsed = Number(value)
    if (!Number.isFinite(parsed)) return fallback
    return Math.max(1, Math.floor(parsed))
  }

  const localStartOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0)
  const localStartOfYear = (date) => new Date(date.getFullYear(), 0, 1, 0, 0, 0)
  const toIsoString = (value) => (value ? value.toISOString() : null)

  const getRangeForPeriod = (period) => {
    const now = new Date()
    if (period === 'ytd') return { start: localStartOfYear(now), end: now }
    if (period === 'all') return { start: new Date(0), end: now }
    return { start: localStartOfMonth(now), end: now }
  }

  const toDateInputValue = (date) => {
    const d = new Date(date)
    if (Number.isNaN(d.getTime())) return ''
    const year = d.getFullYear()
    const month = `${d.getMonth() + 1}`.padStart(2, '0')
    const day = `${d.getDate()}`.padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const fromDateInputValueStart = (value) => {
    if (!value) return null
    const [y, m, d] = value.split('-').map(Number)
    if (!y || !m || !d) return null
    return new Date(y, m - 1, d, 0, 0, 0)
  }

  const fromDateInputValueEnd = (value) => {
    if (!value) return null
    const [y, m, d] = value.split('-').map(Number)
    if (!y || !m || !d) return null
    return new Date(y, m - 1, d, 23, 59, 59)
  }

  const buildRequestUrl = (base, path, params = {}) => {
    const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base
    const normalizedPath = path.startsWith('/') ? path : `/${path}`
    const url = new URL(normalizedPath, normalizedBase)
    Object.entries(params).forEach(([key, value]) => {
      if (value != null) url.searchParams.set(key, value)
    })
    return url.toString()
  }

  const normalizeSearch = (value) => `${value ?? ''}`.trim()

  const renderTable = (container, rows, { page, pageSize }) => {
    container.innerHTML = ''

    const table = document.createElement('table')
    table.className = 'pd-table'

    const thead = document.createElement('thead')
    const hr = document.createElement('tr')
    ;['#', 'Professional', 'Sales', 'Orders'].forEach((label, idx) => {
      const th = document.createElement('th')
      th.textContent = label
      th.style.textAlign = idx <= 1 ? 'left' : 'right'
      hr.appendChild(th)
    })
    thead.appendChild(hr)
    table.appendChild(thead)

    const tbody = document.createElement('tbody')

    if (!rows.length) {
      const tr = document.createElement('tr')
      const td = document.createElement('td')
      td.colSpan = 4
      td.style.textAlign = 'center'
      td.textContent = 'No data available.'
      tr.appendChild(td)
      tbody.appendChild(tr)
    } else {
      rows.forEach((row, index) => {
        const tr = document.createElement('tr')

        const rankTd = document.createElement('td')
        rankTd.textContent = `${(page - 1) * pageSize + index + 1}`
        rankTd.style.textAlign = 'left'
        rankTd.style.opacity = '0.6'
        tr.appendChild(rankTd)

        const nameTd = document.createElement('td')
        nameTd.textContent = row?.name ?? ''
        nameTd.style.textAlign = 'left'
        tr.appendChild(nameTd)

        const salesTd = document.createElement('td')
        salesTd.textContent = formatCurrency(row?.sales)
        salesTd.style.textAlign = 'right'
        tr.appendChild(salesTd)

        const ordersTd = document.createElement('td')
        ordersTd.textContent = `${row?.orders ?? ''}`
        ordersTd.style.textAlign = 'right'
        tr.appendChild(ordersTd)

        tbody.appendChild(tr)
      })
    }

    table.appendChild(tbody)
    container.appendChild(table)
  }

  const initialize = () => {
    const root = document.querySelector(ROOT_SELECTOR)
    if (!root) return

    const apiBase = resolveApiBase(root)
    if (!apiBase) {
      console.error('Full Leaderboard: missing API base URL.')
      return
    }

    ensureStyles()

    const apiPath = root.dataset.apiPath?.trim() || '/api/dashboard/full-leaderboard'
    const pageSize = parseIntSafe(root.dataset.pageSize, 50)

    const metaEl = root.querySelector('[data-meta]')
    const countEl = root.querySelector('[data-count]')
    const tableEl = root.querySelector('[data-table]')
    const pagerEl = root.querySelector('[data-pager]')
    const prevBtn = root.querySelector('[data-page-prev]')
    const nextBtn = root.querySelector('[data-page-next]')
    const pageLabelEl = root.querySelector('[data-page-label]')

    const periodButtons = Array.from(root.querySelectorAll('[data-period-btn]'))
    const sortButtons = Array.from(root.querySelectorAll('[data-sort-btn]'))

    const rangeModal = root.querySelector('[data-range-modal]')
    const rangeStartInput = root.querySelector('[data-range-start]')
    const rangeEndInput = root.querySelector('[data-range-end]')
    const rangeApplyBtn = root.querySelector('[data-apply-range]')
    const rangeCancelEls = Array.from(root.querySelectorAll('[data-range-cancel]'))

    // NEW: search controls
    const searchInput = root.querySelector('[data-search-input]')
    const searchClearBtn = root.querySelector('[data-search-clear]')

    const state = {
      period: 'month',
      sort: 'sales',
      page: 1,
      total: null,
      isLoading: false,
      customStart: null,
      customEnd: null,
      // NEW: search state
      search: ''
    }

    const setMeta = (payload) => {
      if (!metaEl) return
      if (state.period === 'all') {
        metaEl.textContent = ''
        return
      }
      const startLabel = formatDate(payload?.startDate)
      const endLabel = formatDate(payload?.endDate)
      metaEl.textContent = startLabel && endLabel ? `${startLabel} - ${endLabel}` : ''
    }

    const setCount = (payload) => {
      if (!countEl) return
      const total = Number(payload?.total ?? NaN)
      if (!Number.isFinite(total)) {
        countEl.textContent = ''
        return
      }
      countEl.textContent = `${total.toLocaleString()} professionals`
    }

    const setPager = (payload) => {
      if (!pagerEl) return
      const total = Number(payload?.total ?? NaN)
      const pageCount = Number.isFinite(total) ? Math.max(1, Math.ceil(total / pageSize)) : null

      if (!pageLabelEl) return
      pageLabelEl.textContent = pageCount ? `Page ${state.page} of ${pageCount}` : `Page ${state.page}`

      if (prevBtn) prevBtn.disabled = state.page <= 1 || state.isLoading
      if (nextBtn) nextBtn.disabled = pageCount ? state.page >= pageCount || state.isLoading : state.isLoading
    }

    const openRangeModal = () => {
      if (!rangeModal) return
      const now = new Date()
      const defaultStart = localStartOfMonth(now)
      const start = state.customStart || defaultStart
      const end = state.customEnd || now
      if (rangeStartInput) rangeStartInput.value = toDateInputValue(start)
      if (rangeEndInput) rangeEndInput.value = toDateInputValue(end)
      rangeModal.classList.remove('pd-hidden')
      rangeModal.setAttribute('aria-hidden', 'false')
    }

    const closeRangeModal = () => {
      if (!rangeModal) return
      rangeModal.classList.add('pd-hidden')
      rangeModal.setAttribute('aria-hidden', 'true')
    }

    const setActiveButtons = () => {
      periodButtons.forEach((b) => b.classList.toggle('active', b.dataset.period === state.period))
      sortButtons.forEach((b) => b.classList.toggle('active', b.dataset.sort === state.sort))
    }

    // NEW: search UI helpers
    const setSearchUi = () => {
      if (!searchClearBtn) return
      searchClearBtn.style.display = state.search ? '' : 'none'
    }

    // NEW: debounce search requests
    let searchTimer = null
    const queueSearchRequest = () => {
      if (searchTimer) window.clearTimeout(searchTimer)
      searchTimer = window.setTimeout(() => {
        state.page = 1
        requestPayload()
      }, 200)
    }

    const requestPayload = async () => {
      if (state.isLoading) return
      state.isLoading = true
      setPager({ total: state.total })

      if (metaEl) metaEl.textContent = state.period === 'all' ? '' : 'Loading…'

      try {
        let start = null
        let end = null

        if (state.period === 'custom') {
          start = startOfDay(state.customStart)
          end = endOfDay(state.customEnd)
        } else {
          const range = getRangeForPeriod(state.period)
          start = range.start
          end = range.end
        }

        const params = {
          period: state.period,
          sort: state.sort,
          limit: pageSize,
          offset: (state.page - 1) * pageSize
        }

        // NEW: send search to backend
        const search = normalizeSearch(state.search)
        if (search) params.search = search

        const startDate = toIsoString(start)
        const endDate = toIsoString(end)
        if (startDate) params.startDate = startDate
        if (endDate) params.endDate = endDate

        const url = buildRequestUrl(apiBase, apiPath, params)
        const res = await fetch(url, { cache: 'no-cache', headers: { Accept: 'application/json' } })
        const payload = await res.json().catch(() => null)

        if (!res.ok) {
          const message = payload?.error || 'Unable to load leaderboard data.'
          throw new Error(message)
        }

        const rows = Array.isArray(payload?.rows) ? payload.rows : []

        // NEW: client-side fallback filter (in case backend ignores `search`)
        const filteredRows = search
          ? rows.filter((r) => `${r?.name ?? ''}`.toLowerCase().includes(search.toLowerCase()))
          : rows

        renderTable(tableEl, filteredRows, { page: state.page, pageSize })

        state.total = payload?.total ?? state.total
        setMeta(payload)
        setCount(payload)
        setPager(payload)
      } catch (err) {
        if (metaEl) metaEl.textContent = err.message || 'Unable to load leaderboard data.'
        console.error(err)
      } finally {
        state.isLoading = false
        setPager({ total: state.total })
      }
    }

    periodButtons.forEach((btn) => {
      btn.classList.add('pd-btn')
      btn.addEventListener('click', () => {
        const p = btn.dataset.period
        if (!p) return

        if (p === 'custom') {
          state.period = 'custom'
          state.page = 1
          setActiveButtons()
          openRangeModal()
          return
        }

        if (state.period === p) return
        state.period = p
        state.page = 1
        setActiveButtons()
        requestPayload()
      })
    })

    sortButtons.forEach((btn) => {
      btn.classList.add('pd-btn')
      btn.addEventListener('click', () => {
        const s = btn.dataset.sort
        if (!s || state.sort === s) return
        state.sort = s
        state.page = 1
        setActiveButtons()
        requestPayload()
      })
    })

    if (prevBtn) {
      prevBtn.classList.add('pd-btn')
      prevBtn.addEventListener('click', () => {
        if (state.page <= 1) return
        state.page -= 1
        requestPayload()
      })
    }

    if (nextBtn) {
      nextBtn.classList.add('pd-btn')
      nextBtn.addEventListener('click', () => {
        state.page += 1
        requestPayload()
      })
    }

    rangeCancelEls.forEach((el) => el.addEventListener('click', closeRangeModal))

    if (rangeApplyBtn) {
      rangeApplyBtn.addEventListener('click', () => {
        const start = fromDateInputValueStart(rangeStartInput?.value)
        const end = fromDateInputValueEnd(rangeEndInput?.value)

        if (!start || !end) {
          if (metaEl) metaEl.textContent = 'Select both a start and end date.'
          return
        }

        if (start.getTime() > end.getTime()) {
          if (metaEl) metaEl.textContent = 'Start date must be before end date.'
          return
        }

        state.customStart = startOfDay(start)
        state.customEnd = endOfDay(end)
        closeRangeModal()
        state.page = 1
        requestPayload()
      })
    }

    // NEW: search listeners
    if (searchInput) {
      searchInput.addEventListener('input', () => {
        state.search = normalizeSearch(searchInput.value)
        setSearchUi()
        queueSearchRequest()
      })

      searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          state.search = normalizeSearch(searchInput.value)
          setSearchUi()
          state.page = 1
          requestPayload()
        }
      })
    }

    if (searchClearBtn) {
      searchClearBtn.classList.add('pd-btn')
      searchClearBtn.addEventListener('click', () => {
        state.search = ''
        if (searchInput) searchInput.value = ''
        setSearchUi()
        state.page = 1
        requestPayload()
      })
    }

    setActiveButtons()
    setSearchUi()
    requestPayload()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize)
  } else {
    initialize()
  }
})()
